





















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class GooglePhotos extends Vue {
	@Prop({ default: function () {return []}, required: true }) private photos;
	@Prop({ default: '10rem', required: false }) private col_min_height;

	getImgUrl(img_url) {
		return process.env.API_IMG_URL + img_url;
	}

	getOrientation(img_url) {
		const src = this.getImgUrl(img_url);
		const img = new Image();
		img.src = src;
		const res = img.width > img.height ? 'horizontal' : 'vertical';
		return res;
	}
}
